import { USDBalance } from "./types";
import Big from 'bignumber.js';

export const getTotalUSDValues = (balances: USDBalance[]) => {
  if (!Array.isArray(balances)) {
    return '';
  }
  return balances
    .reduce((total, balance) => {
      if (balance.usdValue !== undefined)
        total = total.plus(new Big(balance.usdValue));
      return total;
    }, new Big(0))
    .toFixed();
};
